// Glass cursor: the frosted circle follows a mouse inside any [data-nv-cursor] zone, and
// follows a finger on touch — so the product image reacts the same way on a phone.
// A zone marked data-nv-cursor="mouse" shows it for a mouse only, never under a finger.
// A zone can set data-nv-cursor-icon to "prev" (arrow turns back), "zoom" (magnifying glass),
// "plain" (empty circle) or "none" (no circle, the normal pointer instead); otherwise the arrow
// points forward.
(function () {
  var zones = document.querySelectorAll('[data-nv-cursor]');
  if (!zones.length) return;

  var fineHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 750px)');

  var cursor = document.createElement('div');
  cursor.className = 'nv-cursor';
  cursor.setAttribute('aria-hidden', 'true');
  cursor.innerHTML =
    '<svg class="nv-cursor__arrow" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
    '<line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
    '<svg class="nv-cursor__zoom" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="10.5" cy="10.5" r="6"/><line x1="15" y1="15" x2="20" y2="20"/></svg>';
  document.body.appendChild(cursor);

  var frame = null;
  var point = { x: 0, y: 0 };
  var place = function () {
    frame = null;
    cursor.style.setProperty('--nv-cursor-x', point.x + 'px');
    cursor.style.setProperty('--nv-cursor-y', point.y + 'px');
  };
  var show = function (x, y) {
    point.x = x;
    point.y = y;
    if (!frame) frame = requestAnimationFrame(place);
    cursor.classList.add('is-visible');
  };
  var hide = function () {
    cursor.classList.remove('is-visible');
  };
  // False when the zone wants no circle here: it is put away and the normal pointer shows.
  var aim = function (zone) {
    var icon = zone.dataset.nvCursorIcon;
    zone.classList.toggle('is-cursor-off', icon === 'none');
    if (icon === 'none') {
      hide();
      return false;
    }
    cursor.classList.toggle('is-prev', icon === 'prev');
    cursor.classList.toggle('is-plain', icon === 'plain');
    cursor.classList.toggle('is-zoom', icon === 'zoom');
    return true;
  };

  var activeZone = null;

  Array.prototype.forEach.call(zones, function (zone) {
    if (fineHover.matches) zone.classList.add('is-cursor-zone');

    zone.addEventListener('pointermove', function (event) {
      if (event.pointerType !== 'mouse' || !fineHover.matches) return;
      activeZone = zone;
      if (aim(zone)) show(event.clientX, event.clientY);
    });

    // A click can change what the zone wants (the last photo reached) while the mouse is still.
    if (window.MutationObserver) {
      new MutationObserver(function () {
        if (activeZone === zone && aim(zone)) show(point.x, point.y);
      }).observe(zone, { attributes: true, attributeFilter: ['data-nv-cursor-icon'] });
    }

    // It is positioned against the viewport, so scrolling keeps it under the pointer;
    // only leaving the zone puts it away.
    zone.addEventListener('pointerleave', function (event) {
      if (event.pointerType !== 'mouse') return;
      activeZone = null;
      hide();
    });

    if (zone.dataset.nvCursor === 'mouse') return;

    // Touch: iOS hands drags to the scroller and cancels pointer events, so read touches
    // directly. The circle appears where the finger lands and tracks it while it moves.
    var track = function (event) {
      var touch = event.touches && event.touches[0];
      if (!touch) return;
      if (aim(zone)) show(touch.clientX, touch.clientY);
    };
    zone.addEventListener('touchstart', track, { passive: true });
    zone.addEventListener('touchmove', track, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (type) {
      zone.addEventListener(type, hide, { passive: true });
    });
  });
})();
